import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'dayjs/locale/ja';
import dayjs from 'dayjs';
import '@/filters/dateFilter';
import '@/filters/cdFilter';
import '@/errors/handleError';
import Amplify from 'aws-amplify';
import { amplifyConfig } from '@/amplifyConfig';

// 共通CSS
// tslint:disable-next-line:no-var-requires
require('@/assets/sass/styles.scss');

dayjs.locale('ja');
Amplify.configure(amplifyConfig);

Vue.config.productionTip = false;

const vm = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

export default vm;
